<template>
  <div class="toastSuccess">
    <p class="messageSuccess">
      {{ message }}
    </p>
    <div @click="close" class="cross">
      <span class="cross-title"> X </span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { SUCCESS } from '@/modules/SuccessToaster/store/mutation-types';
import { store } from '@/plugins/store';

export default defineComponent({
    props: {
        message: String,
    },
    computed: {
        loadCross() {
            return require('@/assets/img/warning.png');
        },
    },
    methods: {
        close() {
            store.commit(`successToaster/${SUCCESS.SET_ACTIVE}`, false);
        },
    },
});
</script>

<style>
.messageSuccess {
    color: white;
    width: 250px;
}
.toastSuccess {
  display: flex;
  padding: 5px;
  position: fixed;
  left: 50px;
  background-color: var(--etat-vert);
  width: 300px;
  border-radius: 10px;
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  align-items: center;
  animation: slidein 0.4s ease-in-out forwards;
  z-index: 999;
}
@keyframes slidein {
  from {
    bottom: -100px;
  }

  to {
    bottom: 40px;
  }
}
</style>
